import type { Rule } from 'antd/es/form';

/** One artist per profile — lists like "A, B, C" must be separate artists. */
export const singleArtistNameRules: Rule[] = [
    {
        validator: async (_, value: string) => {
            if (!value || !String(value).includes(',')) {
                return;
            }
            throw new Error('One artist only — do not use commas. Add each artist separately.');
        }
    }
];
